import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { jeffersonCityConfig } from "./data";

export default function JeffersonCityPage() {
  return <CityPageTemplate config={jeffersonCityConfig} />;
}